"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getZoneByState = exports.ZONE_3_STATES = exports.ZONE_2_STATES = exports.ZONE_1_STATES = exports.mockStateHotbait = exports.mockBestSeller = exports.mockStateDetail = exports.mockState = void 0;
const __1 = require("..");
const fishing_report_1 = require("./fishing_report");
const product_1 = require("./product");
const season_1 = require("./season");
const user_profile_1 = require("./user_profile");
const waterbody_1 = require("./waterbody");
function mockState(overrides = {}) {
    return {
        abbr: 'MN',
        bbox: '-97.239209,43.499356,-89.489226,49.384358',
        image: 'http://example.com/jpg.png',
        name: 'Minnesota',
        position: 1,
        slug: 'mn',
        zone_id: 1,
        ...overrides,
    };
}
exports.mockState = mockState;
function mockStateDetail(overrides = {}) {
    return {
        abbr: 'MN',
        ambassadors: [(0, user_profile_1.mockUserProfilePrivate)()],
        banner_image: 'http://example.com/banner.png',
        bbox: '-97.239209,43.499356,-89.489226,49.384358',
        brands: [],
        best_sellers: [],
        current_season: (0, season_1.mockSeason)(),
        description: 'mock description',
        hotbaits: [],
        image: 'http://example.com/jpg.png',
        meta_description: 'mock meta_description',
        meta_title: 'mock meta_title',
        name: 'Minnesota',
        page_heading: 'mock page_heading',
        page_subheading: 'mock page_subheading',
        position: 1,
        seasons: [(0, season_1.mockSeason)()],
        season_groups: [(0, __1.mockSeasonGroup)()],
        slug: 'mn',
        top_waterbodies: [],
        zone_id: 1,
        ...overrides,
    };
}
exports.mockStateDetail = mockStateDetail;
function mockBestSeller(overrides = {}) {
    return {
        product: (0, product_1.mockProduct)(),
        ...overrides,
    };
}
exports.mockBestSeller = mockBestSeller;
function mockStateHotbait(overrides = {}) {
    return {
        product: (0, product_1.mockProduct)(),
        waterbodies: [(0, waterbody_1.mockWaterbody)()],
        fishing_reports: [(0, fishing_report_1.mockFishingReport)()],
        ...overrides,
    };
}
exports.mockStateHotbait = mockStateHotbait;
exports.ZONE_1_STATES = ['AL', 'AZ', 'FL', 'GA', 'HI', 'LA', 'MS', 'NM', 'SC', 'TX'];
exports.ZONE_2_STATES = [
    'AR',
    'CA',
    'CO',
    'DC',
    'DE',
    'IA',
    'IL',
    'IN',
    'KS',
    'KY',
    'MD',
    'MO',
    'NC',
    'NE',
    'NJ',
    'NV',
    'OH',
    'OK',
    'PA',
    'TN',
    'UT',
    'VA',
    'WV',
    'WY',
];
exports.ZONE_3_STATES = [
    'AK',
    'CT',
    'ID',
    'MA',
    'ME',
    'MI',
    'MN',
    'MT',
    'ND',
    'NH',
    'NY',
    'OR',
    'RI',
    'SD',
    'VT',
    'WA',
    'WI',
];
const getZoneByState = (abbr) => {
    if (exports.ZONE_1_STATES.includes(abbr)) {
        return 1;
    }
    else if (exports.ZONE_2_STATES.includes(abbr)) {
        return 2;
    }
    else if (exports.ZONE_3_STATES.includes(abbr)) {
        return 3;
    }
    return 3;
};
exports.getZoneByState = getZoneByState;
